import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { authen } from '../../firebase/firebase';
import { onAuthStateChanged } from 'firebase/auth';

interface props {
  view: string;
}
const ColumnGroupingTable = ({ view }: props) => {
  const profile = useSelector((state: any) => state.userprofile);

  const correctWords = profile?.user?.metrics?.last_words_correct;

  const correctWordArray = correctWords && correctWords.split('|');
  // const adUnitId = TestIds.ADAPTIVE_BANNER;
  const [user, setUser] = React.useState<any>();

  const parseIncorrectWordString = (input: string) => {
    return (
      input &&
      input.split('|').map((pair) => {
        const [key, value] = pair.split('=');
        return { key, value };
      })
    );
  };
  const incorrectWordArray = parseIncorrectWordString(
    profile?.user?.metrics?.last_words_incorrect
  );

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(authen, (currentUser) => {
      setUser(currentUser); // Update the user state
    });
    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, []);
  return (
    <Paper sx={{ width: '100%', borderRadius: '14px', boxShadow: 'none' }}>
      {authen?.currentUser?.isAnonymous ? (
        <Typography
          sx={{
            fontWeight: '700',
            fontSize: '20px',
            fontFamily: 'Mulish',
          }}
          variant="body2"
          color="#333333"
          gutterBottom
        >
          Sign up to track your spelling history!
        </Typography>
      ) : view == '1' ? (
        <>
          {incorrectWordArray === undefined ||
          incorrectWordArray.length === 0 ? (
            <Typography
              sx={{
                fontWeight: '700',
                fontSize: '20px',
                fontFamily: 'Mulish',
              }}
              variant="body2"
              color="#333333"
              gutterBottom
            >
              Attempt spelling to see your history!
            </Typography>
          ) : (
            <>
              {' '}
              <Box
                sx={{
                  paddingBottom: '10px',
                  display: 'grid',
                  alignItems: 'center',
                  gridTemplateColumns: '50% 50%',
                  gap: '10px',
                }}
                className="table-heading"
              >
                <Typography
                  sx={{
                    fontWeight: '700',
                    fontSize: '20px',
                    fontFamily: 'Mulish',
                  }}
                  variant="body2"
                  color="#333333"
                  gutterBottom
                >
                  Your attempted spelling
                </Typography>
                <Typography
                  sx={{
                    fontWeight: '700',
                    fontSize: '20px',
                    fontFamily: 'Mulish',
                  }}
                  variant="body2"
                  color="#333333"
                  gutterBottom
                >
                  Correct spelling
                </Typography>
              </Box>
              <TableContainer
                className="table-scrolling"
                sx={{
                  maxHeight: 440,
                  scrollbarWidth: 'thin',
                  borderRadius: '8px',
                  border: '3.7px solid #878787',
                }}
              >
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{ borderRadius: '14px' }}
                >
                  <TableHead>{/* Table Head content */}</TableHead>

                  {view == '1' && (
                    <TableBody>
                      {incorrectWordArray &&
                        incorrectWordArray.map(({ key, value }, index) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={key}
                          >
                            <TableCell
                              className="first-cell"
                              sx={{
                                borderRight: ' 1.85px solid #CCCCCC',
                                color: '#F14249',
                                fontWeight: '700',
                                fontSize: { sm: '20px', md: '20px' },
                                fontFamily: 'Mulish',
                              }}
                            >
                              {!authen?.currentUser?.isAnonymous ? value : '--'}
                            </TableCell>
                            <TableCell
                              className="second-cell"
                              sx={{
                                color: '#2A9235',
                                fontWeight: '700',
                                fontSize: { sm: '20px', md: '20px' },
                                fontFamily: 'Mulish',
                              }}
                            >
                              {!authen?.currentUser?.isAnonymous ? key : '--'}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  )}
                  {/* {view == '2' && (
                    <TableBody>
                      {correctWordArray &&
                        correctWordArray.map((word: string, index: number) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            <TableCell
                              className="first-cell"
                              sx={{
                                borderRight: ' 1.85px solid #CCCCCC',
                                color: '#2A9235',
                                fontWeight: '700',
                                fontSize: { sm: '20px', md: '20px' },
                                fontFamily: 'Mulish',
                              }}
                            >
                              {!authen?.currentUser?.isAnonymous ? word : '--'}
                            </TableCell>
                            <TableCell
                              className="second-cell"
                              sx={{
                                color: '#2A9235',
                                fontWeight: '700',
                                fontSize: { sm: '20px', md: '20px' },
                                fontFamily: 'Mulish',
                              }}
                            >
                              {!authen?.currentUser?.isAnonymous ? word : '--'}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  )} */}
                </Table>
              </TableContainer>
            </>
          )}
        </>
      ) : (
        view == '2' && (
          <>
            {correctWordArray === undefined || correctWordArray.length === 0 ? (
              <Typography
                sx={{
                  fontWeight: '700',
                  fontSize: '20px',
                  fontFamily: 'Mulish',
                }}
                variant="body2"
                color="#333333"
                gutterBottom
              >
                Attempt spelling to see your history!
              </Typography>
            ) : (
              <>
                {' '}
                <Box
                  sx={{
                    paddingBottom: '10px',
                    display: 'grid',
                    alignItems: 'center',
                    gridTemplateColumns: '50% 50%',
                    gap: '10px',
                  }}
                  className="table-heading"
                >
                  <Typography
                    sx={{
                      fontWeight: '700',
                      fontSize: '20px',
                      fontFamily: 'Mulish',
                    }}
                    variant="body2"
                    color="#333333"
                    gutterBottom
                  >
                    Your attempted spelling
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: '700',
                      fontSize: '20px',
                      fontFamily: 'Mulish',
                    }}
                    variant="body2"
                    color="#333333"
                    gutterBottom
                  >
                    Correct spelling
                  </Typography>
                </Box>
                <TableContainer
                  className="table-scrolling"
                  sx={{
                    maxHeight: 440,
                    scrollbarWidth: 'thin',
                    borderRadius: '8px',
                    border: '3.7px solid #878787',
                  }}
                >
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    sx={{ borderRadius: '14px' }}
                  >
                    <TableHead>{/* Table Head content */}</TableHead>

                    {/* {view == '1' && (
                      <TableBody>
                        {incorrectWordArray &&
                          incorrectWordArray.map(({ key, value }, index) => (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={key}
                            >
                              <TableCell
                                className="first-cell"
                                sx={{
                                  borderRight: ' 1.85px solid #CCCCCC',
                                  color: '#F14249',
                                  fontWeight: '700',
                                  fontSize: { sm: '20px', md: '20px' },
                                  fontFamily: 'Mulish',
                                }}
                              >
                                {!authen?.currentUser?.isAnonymous
                                  ? value
                                  : '--'}
                              </TableCell>
                              <TableCell
                                className="second-cell"
                                sx={{
                                  color: '#2A9235',
                                  fontWeight: '700',
                                  fontSize: { sm: '20px', md: '20px' },
                                  fontFamily: 'Mulish',
                                }}
                              >
                                {!authen?.currentUser?.isAnonymous ? key : '--'}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    )} */}
                    {view == '2' && (
                      <TableBody>
                        {correctWordArray &&
                          correctWordArray.map(
                            (word: string, index: number) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                <TableCell
                                  className="first-cell"
                                  sx={{
                                    borderRight: ' 1.85px solid #CCCCCC',
                                    color: '#2A9235',
                                    fontWeight: '700',
                                    fontSize: { sm: '20px', md: '20px' },
                                    fontFamily: 'Mulish',
                                  }}
                                >
                                  {!authen?.currentUser?.isAnonymous
                                    ? word
                                    : '--'}
                                </TableCell>
                                <TableCell
                                  className="second-cell"
                                  sx={{
                                    color: '#2A9235',
                                    fontWeight: '700',
                                    fontSize: { sm: '20px', md: '20px' },
                                    fontFamily: 'Mulish',
                                  }}
                                >
                                  {!authen?.currentUser?.isAnonymous
                                    ? word
                                    : '--'}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </>
            )}
          </>
        )
      )}
    </Paper>
  );
};
export default ColumnGroupingTable;
